import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { OWNER_ASSIGNED_DATE } from 'customer-data-objects/task/TaskPropertyNames';
import TimezoneTypes from 'I18n/constants/TimezoneTypes';
import DateTimeCell from './DateTimeCell';
import { jsx as _jsx } from "react/jsx-runtime";
const TaskOwnerAssignedDateCell = ({
  original: cdtTask
}) => {
  const ownerAssignedDate = getProperty(cdtTask, OWNER_ASSIGNED_DATE);
  return /*#__PURE__*/_jsx(DateTimeCell, {
    format: "LLL",
    i18nTimezoneType: TimezoneTypes.USER,
    value: ownerAssignedDate
  });
};
export default TaskOwnerAssignedDateCell;